import axios from "http/customAxios";

type CustomDataPropertyARIType = {
  [key: string]: {
    ticker: string;
    name: string;
    price: number;
    averageRate: number;
    originalRate: number;
    rackRate: number;
    cityTax: number;
  };
};

type PartyType = {
  adults: number;
  children: number[];
};

type CategoryType = {
  room_type_details: boolean;
  rate_plan_details: boolean;
  room_rate_details: boolean;
  hotel_details: boolean;
};

type CategoryModifiersType = {
  partner_booking_data: boolean;
  real_time_pricing: boolean;
  multiple_room_rates: boolean;
  photos: boolean;
  text: boolean;
};

type hotelsType = {
  partner_hotel_code: string;
};

type BodyTripadvisorType = {
  api_version: number;
  start_date: string;
  end_date: string;
  party: PartyType[];
  language: string; // language is global
  currency: string;
  device_type: string;
  requested_payload: {
    categories: CategoryType;
    category_modifiers: CategoryModifiersType;
  };
  hotels: hotelsType[];
};

type ItemResultJsonType = {
  type: string
  expectedValue?: number
  givenValue?: number
  value?: string
}

type ResultJsonType = {
  [key: string]: {
    gha: {
      discrepancies: ItemResultJsonType[],
    },
    tripadvisor: {
      discrepancies: ItemResultJsonType[],
    },
    trivago: {
      discrepancies: ItemResultJsonType[],
    },
  },
}

type InitialResultJsonType = {
  propertyTicker: string,
  results : ResultJsonType
}

const getDataTripadvisor = (
  URLTripadvisor: string,
  body: BodyTripadvisorType
) => {
  return axios.post(URLTripadvisor, body);
};

const priceIsWrong = (
  ARIprice: number,
  TipadvisorPrice: number,
  tolerance: number
) => (Math.abs(ARIprice - TipadvisorPrice) > tolerance ? true : false);

export const tripadvisorCompareToARI = async (
  URL_TRIPADVISOR: string,
  BODY_TRIPADVISOR: BodyTripadvisorType,
  customPropertyARI: CustomDataPropertyARIType,
  propertyTicker: string,
  tolerance: number,
  initialResultJson: InitialResultJsonType,
  nameHasDiscrepancies: string[],
  setNameHasDiscrepancies: Function
) => {
  const { data: dataTripadvisor } = await getDataTripadvisor(
    URL_TRIPADVISOR,
    BODY_TRIPADVISOR
  );
  if (dataTripadvisor.hotels[propertyTicker] && dataTripadvisor.hotels[propertyTicker].available) {
    const roomRates =
      dataTripadvisor.hotels[propertyTicker].available.room_rates;
    for (const key in roomRates) {
      let totalPriceTripadvisor = 0;
      roomRates[key].line_items.forEach((element: any) => {
        totalPriceTripadvisor += element.price.requested_currency_price.amount;
      });
      totalPriceTripadvisor =
        Math.round((totalPriceTripadvisor + Number.EPSILON) * 100) / 100;
      if (customPropertyARI[roomRates[key].persistent_room_rate_code]) {
        if (
          priceIsWrong(
            customPropertyARI[roomRates[key].persistent_room_rate_code].price,
            totalPriceTripadvisor,
            tolerance
          )
        ) {
          setNameHasDiscrepancies((prevValue: string[]) => [...prevValue, "tripadvisor"])
          initialResultJson.results[
            roomRates[key].persistent_room_rate_code
          ].tripadvisor.discrepancies.push({
            type: "PRICE",
            expectedValue:
              customPropertyARI[roomRates[key].persistent_room_rate_code].price,
            givenValue: totalPriceTripadvisor,
          });
        } else {
          //is okey
          //console.info(`El precio de tripadvisor esta bien en ${roomRates[key].persistent_room_rate_code}`);
        }
      } else {
        initialResultJson.results[
          roomRates[key].persistent_room_rate_code
        ].tripadvisor.discrepancies.push({
          type: "PROPERTYARI_NOT_FOUND",
          value: roomRates[key].persistent_room_rate_code,
        });
      }
    }
  } else {
    initialResultJson.results["not_records"].tripadvisor.discrepancies.push({
      type: "EMPTY",
      value: "Has no records",
    });
  }
  return dataTripadvisor
};

export const runTripadvisor = async ({config, customPropertyARI, tolerance, initialResultJson, nameHasDiscrepancies, setNameHasDiscrepancies, urlTripadvisor}: any) => {
  const RUN_BODY_TRIPADVISOR: BodyTripadvisorType = {
    api_version: 8,
    start_date: config.start,
    end_date: config.end,
    party: [
      {
        adults: config.adults,
        children: [],
      },
    ],
    language: "en_US", // language is global
    currency: config.currency,
    device_type: config.deviceInfo.deviceType,
    requested_payload: {
      categories: {
        room_type_details: false,
        rate_plan_details: false,
        room_rate_details: true,
        hotel_details: false,
      },
      category_modifiers: {
        partner_booking_data: false,
        real_time_pricing: false,
        multiple_room_rates: false,
        photos: false,
        text: false,
      },
    },
    hotels: [
      {
        partner_hotel_code: `${config.propertyTicker}`,
      },
    ],
  };
  const runResTripadvisor = await tripadvisorCompareToARI(
    urlTripadvisor,
    RUN_BODY_TRIPADVISOR,
    customPropertyARI,
    config.propertyTicker,
    tolerance,
    initialResultJson,
    nameHasDiscrepancies,
    setNameHasDiscrepancies
  );
  return {
    RUN_BODY_TRIPADVISOR,
    runResTripadvisor
  }
}